<template>
  <div :class="disabled ? 'disabled' : ''" class="toggle">
    <label class="d-flex align-content-between w-100">
      <span class="flex-grow-1">{{ label }}</span>
      <input
        :id="id ?? name"
        :checked="value ?? false"
        :disabled="disabled"
        :name="name"
        class="d-none"
        type="checkbox"
        @change="updateData($event.target.checked)"
      />
      <div class="toggle_fill"></div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: { type: String, default: () => '' },
    name: { type: String, default: () => '' },
    label: { type: String, default: () => '' },
    value: { type: Boolean, default: () => false },
    disabled: { type: Boolean, default: () => false },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const updateData = (data) => {
      setTimeout(function () {
        emit('update:data', data);
      }, 200);
    };

    return {
      updateData,
    };
  },
};
</script>

<style lang="scss">
.toggle {
  display: flex;
  justify-content: flex-end;
  & ~ label {
    display: none;
  }
  .toggle_fill {
    position: relative;
    cursor: pointer;
    width: 3em;
    height: 1.5em;
    border-radius: 0.75em;
    background: #ccc;
    transition: background 0.2s;
    &::after {
      content: '';
      position: absolute;
      left: 0.125em;
      top: 0.125em;
      height: 1.25em;
      width: 1.25em;
      background: #fff;
      box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.25);
      border-radius: 50%;
      transition: transform 0.2s;
    }
  }
  input:checked ~ .toggle_fill {
    background: var(--primary-color);
  }

  input:checked ~ .toggle_fill::after {
    transform: translateX(1.45em);
  }
}
</style>
